<template>
    <div>
        <TransactionPage type="customer" />
    </div>
</template>
  
<script>
import TransactionPage from '@/components/transaction/TransactionPage.vue';

export default {
    components: {
        TransactionPage
    }
};
</script>